import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from '../service/auth.service';
import { DateService } from '../date.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { AdminBookingsService } from '../service/admin-bookings.service';
import { DatePipe, DOCUMENT } from '@angular/common';
import { AppConstants } from '../AppConstants';
@Component({
  selector: 'app-booked-details',
  templateUrl: './booked-details.component.html',
  styleUrls: ['./booked-details.component.css']
})
export class BookedDetailsComponent implements OnInit {
  dataContent: string;
  cancelBookingResponse: any;
  datePipe: DatePipe = new DatePipe('en-US');
  roleId: number = 0;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private authService: AuthService, public dateService: DateService,
    public dialogRef: MatDialogRef<BookedDetailsComponent>,
    private dialog: MatDialog,
    private adminBookingSvc: AdminBookingsService) { }

  ngOnInit() {
    this.authService.syncUserContext();
    const externalUserContext = this.authService.getStoredItem(AppConstants.SESSION_STORAGE_EXTERNAL_USER_CONTEXT);
    const currentUserContext = this.authService.getStoredItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT);

    if (externalUserContext) {
      this.roleId = Number(JSON.parse(externalUserContext).roleId);
    } else if (currentUserContext) {
      this.roleId = Number(JSON.parse(currentUserContext).roleId);
    } else {
      this.roleId = Number(AppConstants.SESSION_STORAGE_ROLEID || 0);
    }

    this.dataContent = JSON.stringify(this.data);
    console.log("Booking Details : ", this.data);

  }

  formatDate(dateString) {
    // Create a new Date object from the provided date string
    var date = new Date(dateString);

    // Define options for formatting the date
    var options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
      timeZone: 'UTC' // Adjust as per your time zone if needed
    };

    // Format the date using the specified options
    var formattedDate = date.toLocaleDateString('en-GB', options);

    return formattedDate;
  }

  getFormattedDateWithTime(dateAndTime) {
    return this.datePipe.transform(dateAndTime, 'dd-MMM hh:mm a');
  }

  removeBooking(data) {
    alert(JSON.stringify(data));
  }

  cancelBooking() {
    this.cancelBookingResponse = this.authService.cancelBooking(this.data.bookingId).subscribe(
      (response: any) => {
        console.log("Booking Cancelled for the Booking ID: ", this.data.bookingId);
      },
      (error) => {
        console.log('Cancellation Failed :' + JSON.stringify(error));
      }
    )
  }

  deleteSlot(slotInfo) {
    const dialogRefConfirm = this.dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      data: { message: 'Are you sure you want to cancel the booking slot?' },
      panelClass: 'confirmation-dialog-container'
    });

    console.log("Slot Info : ", slotInfo);
    // Handle dialog closing
    dialogRefConfirm.afterClosed().subscribe(result => {
      if (result) {
        // User confirmed, cancel the booking
        // const slotId = slotInfo.tenantId + '_' + slotInfo.productId + '_' + this.getDateStrFromTime(slotInfo.bookingDate)
        //   + '_' + slotInfo.startTime + '_' + slotInfo.endTime + '_' + slotInfo.venueId;
        this.authService.cancelSlots([slotInfo.slotId], slotInfo.bookingId).subscribe(
          (response: any) => {
            this.dialogRef.close(true);

            //this.adminBookingSvc.setRefreshPage(true);
            this.adminBookingSvc.setReloadPage(true);
            // this.adminBookingSvc.reloadData.next({
            //   reloadData: true,
            //   cancelledSlot: true
            // });

            console.log("Booking Cancelled for the Booking ID: ", slotInfo.slotId);
          },
          (error) => {
            console.log('Cancellation Failed :' + JSON.stringify(error));
          }
        );
      } else {
        // User cancelled, do nothing or handle accordingly
      }
    });


  }

  isAdminRole(): boolean {
    return this.roleId === 1 || this.roleId === 2;
  }

  canDeleteSlot(slotInfo: any): boolean {
    const status = this.normalizeStatus(slotInfo?.status || slotInfo?.bookingStatus);
    return this.isAdminRole() && (status === 'booked' || status === 'waitingforpayment');
  }

  normalizeStatus(status: any): string {
    return String(status || '').toLowerCase().replace(/\s+/g, '');
  }

  getDateStrFromTime(timeValue) {
    const date = new Date(timeValue);
    return date.getFullYear() + '-' + this.addZeroIfRequired(date.getMonth() + 1) + '-' +
      this.addZeroIfRequired(date.getDate());
  }

  addZeroIfRequired(value: number) {
    if (value > 9) {
      return value;
    }
    return '0' + value;
  }

 getExpiry(data) {
  const bookedOn = data.bookedOn;
  const config = data.config;
  const durationMinutes = JSON.parse(config).expiryDuration;
  let formattedDate;
  if(durationMinutes === -1) {
    formattedDate = "No Expiry";
  } else {
    const bookedDate = new Date(bookedOn);
    const expiryDate = new Date(bookedDate.getTime() + durationMinutes * 60 * 1000);
    formattedDate = expiryDate.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    });
    console.log(formattedDate);
  }
  return formattedDate;
 }



}
